export default "__VITE_ASSET__CVUT3BSw__"